import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from './Icons';

const SuccessScreen = ({ student, reason, otherReason, onBackToHome, sheetsService }) => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((c) => c - 1);
    }, 1000);

    const redirect = setTimeout(() => {
      onBackToHome();
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, [onBackToHome]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <CheckCircleIcon className="mx-auto h-16 w-16 text-green-500 mb-6" />
        
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Signout Recorded!</h2>
        <p className="text-sm text-gray-600 mb-4">Returning to home in {Math.max(0, countdown)}s...</p>
        
        <div className="mb-6 text-left bg-gray-50 rounded-lg p-4">
          <div className="mb-2">
            <span className="font-medium text-gray-700">Student:</span>
            <span className="ml-2 text-gray-900">{student.name}</span>
          </div>
          <div className="mb-2">
            <span className="font-medium text-gray-700">Reason:</span>
            <span className="ml-2 text-gray-900">{reason}</span>
          </div>
          {otherReason && (
            <div className="mb-2">
              <span className="font-medium text-gray-700">Details:</span>
              <span className="ml-2 text-gray-900">{otherReason}</span>
            </div>
          )}
          <div>
            <span className="font-medium text-gray-700">Time:</span>
            <span className="ml-2 text-gray-900">{new Date().toLocaleTimeString()}</span>
          </div>
        </div>
        
        <button
          onClick={onBackToHome}
          className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
        >
          Back to Home {countdown > 0 ? `(${countdown})` : ''}
        </button>
      </div>
    </div>
  );
};

export default SuccessScreen;
